import { useSearchBox } from "react-instantsearch"

export function VirtualQuery(props:any) {
  useSearchBox(props);
  return null;
}
